import { createSlice } from '@reduxjs/toolkit';
import { remove } from 'lodash';
import { getCookie } from '../utils';

const modifyNotification = ({ id, type, success, errorMessage, message, code, closable, log }) => {
    let msgItem = {};
    msgItem.id = id;
    msgItem.type = type
        ? type
        : typeof success == "boolean"
            ? success
                ? "success"
                : "error"
            : "info";
    msgItem.code = code || null;
    msgItem.message = message || errorMessage || "Unknown error";
    msgItem.closable = typeof closable == "boolean" ? closable : true;
    msgItem.log = log;

    return msgItem;
};

const notifications = createSlice({
    name: "notifications",
    initialState: {
        notifications: []
    },
    reducers: {
        setNotification: {
            reducer: (state, action) => {
                if (getCookie('csrf_access_token')) {
                    state.notifications.push(modifyNotification(action.payload));
                }
            },
            prepare: (notification) => {
                notification.id = `error-${Date.now()}`;
                return { payload: notification };
            }
        },
        removeNotification: (state, action) => {
            remove(state.notifications, { id: action.payload });
        },
        showNotification: {
            reducer: (state, action) => {
                state.notifications.push(modifyNotification(action.payload));
            },
            prepare: (message, type) => {
                if (!["error", "success", "warning", "info"].includes(type)) type = "info";
                return { payload: {
                    type: type,
                    message: message
                }}
            }
        }
    }
});


export const { setNotification, removeNotification, showNotification } = notifications.actions;
export default notifications.reducer;